<template>
  <div class="z-50 w-full py-2 transition-all">
    <div class="z-50 w-full h-full p-0 overflow-y-auto rounded-lg">
      <div
        :class="[search_open ? 'bg-white border h-80' : 'dark:bg-dark-screen-background']"
        class="w-full overflow-hidden transition-all transform rounded-lg shadow-lg">
        <Combobox v-model="selected_item" @update:modelValue="openRecordDetailsPage">
          <div
            v-click-outside="
              () => {
                search_open = false
                query = ''
              }
            "
            class="relative"
            :class="[!search_open ? 'bg-white rounded-lg border py-0' : '']">
            <Search class="pointer-events-none z-10 absolute top-2.5 left-4 h-5 w-5 text-gray-400" aria-hidden="true" />
            <ComboboxInput
              :value="query"
              name="search_item"
              class="w-full h-10 pr-4 text-gray-800 placeholder-gray-400 bg-white border-0 rounded-lg pl-11 dark:text-white focus:ring-0"
              :placeholder="$t('Search...')"
              autocomplete="off"
              @keydown.prevent.esc="close"
              @click="search_open = true"
              @change="query = $event.target.value" />
            <Spinner
              v-if="is_searching"
              class="pointer-events-none absolute top-3.5 right-4 mr-0.5 h-5 w-5 text-gray-400"
              aria-hidden="true" />
            <div v-else-if="search_open" class="absolute flex flex-wrap justify-end gap-2 px-2 pb-2 top-1 right-1">
              <!-- Object type filter -->
              <Listbox as="div" multiple class="flex-shrink-0">
                <ListboxLabel class="sr-only">
                  {{ $t("Add a type") }}
                </ListboxLabel>
                <div class="relative">
                  <ListboxButton class="relative flex items-center w-full -mt-1 rounded-full whitespace-nowrap group">
                    <div class="flex justify-between gap-1 pr-2">
                      <div
                        v-for="obj in selected_object_types"
                        :key="obj.type"
                        class="relative inline-flex items-center px-2 py-2 text-sm text-gray-500 rounded-full whitespace-nowrap bg-gray-50 dark:bg-dark-box-background hover:bg-gray-100 sm:px-3">
                        <span class="text-gray-900 truncate dark:text-white sm:ml-2 sm:block">{{ obj.plural_label || obj.label }}</span>
                      </div>
                    </div>
                    <Funnel
                      class="flex-shrink-0 w-10 h-10 text-sm font-medium text-gray-500 rounded-full group-hover:bg-gray-100 dark:group-hover:bg-dark-box-background sm:px-3 sm:-ml-1"
                      aria-hidden="true"
                      @click="search_open = true" />
                  </ListboxButton>

                  <ListboxOptions
                    class="absolute right-0 z-10 py-3 mt-0 overflow-auto text-base bg-white rounded-lg shadow-lg max-h-56 w-52 dark:bg-dark-box-background ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                    <ListboxOption
                      v-for="object_type in object_types"
                      :key="object_type.id"
                      v-slot="{ active }"
                      as="template"
                      :value="object_type">
                      <li
                        :class="[
                          active ? '!bg-blue opacity-80 text-white' : '',
                          selected_object_types
                            .map((x) => x?.type)
                            .filter((x) => x)
                            .includes(object_type.type)
                            ? '!bg-blue text-white'
                            : 'dark:bg-dark-box-background',
                          'relative cursor-default select-none py-2 px-3'
                        ]"
                        @click.stop="itemClicked(object_type)">
                        <div class="flex items-center">
                          <span class="block text-sm font-medium truncate dark:text-white">
                            {{ object_type?.plural_label || object_type.label }}</span>
                        </div>
                      </li>
                    </ListboxOption>
                  </ListboxOptions>
                </div>
              </Listbox>
              <!-- End -->
            </div>
          </div>

          <div :class="[search_open ? 'h-80' : ' h-0 pointer-events-none']" class="transition-all">
            <div class="absolute w-full p-2 space-y-2 rounded-lg shadow-lg h-80">
              <ComboboxOptions
                v-if="Object.entries(filtered_items).length > 0"
                static
                class="w-full h-full pb-2 space-y-2 overflow-y-auto rounded-lg shadow-lg">
                <li v-for="[type, items] in Object.entries(filtered_items)" :key="type">
                  <h2
                    class="bg-gray-100 py-2.5 px-4 text-sm font-semibold text-gray-900 dark:text-white dark:bg-dark-box-background capitalize">
                    {{ type }}
                  </h2>
                  <ul class="mt-2 text-sm text-gray-800">
                    <ComboboxOption v-for="item in items"
                                    :key="item.id"
                                    v-slot="{ active }"
                                    :value="item"
                                    as="template">
                      <li :class="['cursor-pointer select-none px-4 py-2 dark:text-gray-300', active && '!bg-blue text-white']">
                        {{ item.name }}
                      </li>
                    </ComboboxOption>
                  </ul>
                </li>
              </ComboboxOptions>
            </div>
            <div
              v-if="
                ((query === '' || is_searching) && Object.entries(filtered_items).length == 0) ||
                  (query !== '' && !is_searching && Object.entries(filtered_items).length === 0)
              "
              class="absolute w-full px-6 text-sm border-t border-gray-100 h-80 dark:border-gray-700">
              <div class="flex flex-col items-center">
                <SearchX class="w-6 h-6 mt-3 text-common-grey" />
                <p class="flex items-center mt-3 mb-1 font-semibold text-gray-900 dark:text-white">
                  {{ $t("No results found") }}
                </p>
                <div class="border-b border-0.5 w-full" />
              </div>
              <div v-if="search_history.length" class="text-right">
                <p class="flex items-start mt-3 font-semibold text-gray-900 dark:text-white">
                  {{ $t("Latest searches") }}
                </p>
                <Listbox as="div">
                  <transition
                    leave-active-class="transition duration-100 ease-in"
                    leave-from-class="opacity-100"
                    leave-to-class="opacity-0">
                    <ListboxOptions
                      id="search-history"
                      static
                      class="w-full py-1 mt-1 overflow-auto text-base bg-white focus:outline-none sm:text-sm dark:bg-dark-box-background">
                      <ListboxOption v-for="item in search_history" :key="item" as="template" :value="item">
                        <li
                          class="relative flex py-2 text-gray-900 cursor-pointer hover:bg-gray-200 dark:text-white dark:hover:bg-transparent"
                          @click.stop="query = item">
                          <History class="w-5 h-5 ml-1 text-gray-400 pointer-events-none" aria-hidden="true" />
                          <span class="flex ml-2 font-normal"> {{ item }} </span>
                        </li>
                      </ListboxOption>
                    </ListboxOptions>
                  </transition>
                </Listbox>
              </div>
              <p v-else class="flex items-center justify-center w-full mt-2 text-gray-500">
                {{ $t("We couldn't find anything with that term. Please try again.") }}
              </p>
            </div>
          </div>
        </Combobox>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from "@/components/shared/LoadingSpinner.vue"
import { Funnel, History, SearchX, Search } from "lucide-vue-next"
import { Combobox, ComboboxOptions, ComboboxInput, ComboboxOption } from "@headlessui/vue"
import { utils } from "@/store/helpers"
import { Listbox, ListboxButton, ListboxOptions, ListboxOption, ListboxLabel } from "@headlessui/vue"
import { Record } from "@/models/record"
import dataService from "@/services/data.service"

export default {
  components: {
    ComboboxInput,
    ListboxLabel,
    Spinner,
    SearchX,
    History,
    Search,
    Funnel,
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
    Combobox,
    ComboboxOptions,
    ComboboxOption
  },

  data() {
    return {
      object_types: [{ id: 1, type: this.$t("All"), label: this.$t("All") }].concat(this.$store.state.object_types),
      search_history: [],
      selected_object_types: [],
      selected_item: null,
      query: "",
      is_searching: false,
      filtered_items: [],
      search_open: false,
      change_timeout: null
    }
  },

  watch: {
    query() {
      if (this.query) {
        clearTimeout(this.change_timeout)
        this.change_timeout = setTimeout(() => {
          this.findRecords()
        }, 500)
      } else {
        this.filtered_items = []
      }
    }
  },

  activated() {
    let selected_objects = [{ id: 1, type: this.$t("All"), label: this.$t("All") }]
      .concat(this.$store.state.ui_options?.palette_search_selected_object_types)
      ?.map((x) => this.$store.state.object_types.find((o) => o?.type == x)) || [
      this.$t("All"),
      this.$t("contact"),
      this.$t("company"),
      this.$t("opportunity")
    ]
    if (this.selected_object_types?.length == 0) {
      this.selected_object_types = [{ id: 1, type: this.$t("All"), label: this.$t("All") }]
      this.$store.dispatch("ui/setUIValue", {
        palette_search_selected_object_types: [{ id: 1, type: this.$t("All"), label: this.$t("All") }]
      })
    } else {
      this.selected_object_types = [...new Set(selected_objects)]
    }
  },
  created() {
    this.search_history = this.$store.state.ui_options?.palette_search_history ? this.$store.state.ui_options.palette_search_history : []
  },
  methods: {
    itemClicked(item) {
      if (item?.type == this.$t("All")) {
        this.selected_object_types = [{ id: 1, type: this.$t("All"), label: this.$t("All") }]
        this.$store.dispatch("ui/setUIValue", {
          palette_search_selected_object_types: [{ id: 1, type: this.$t("All"), label: this.$t("All") }]
        })
      } else {
        let index = this.selected_object_types.findIndex((o) => o.type == item.type)
        if (index != -1) {
          this.selected_object_types.splice(index, 1)
        } else {
          this.selected_object_types.push(item)
        }
        index = this.selected_object_types.findIndex((o) => o.type == "All")
        if (index != -1) {
          this.selected_object_types.splice(index, 1)
        }
        let selected_objects = [...new Set(this.selected_object_types)]
        this.$store.dispatch("ui/setUIValue", {
          palette_search_selected_object_types: selected_objects.map((o) => o?.type).filter((x) => x)
        })
      }
      if (this.query) {
        this.findRecords()
      }
    },
    close() {
      this.query = ""
      this.$store.commit("ui/toggleSearchPalette", false)
    },
    openRecordDetailsPage(record) {
      this.$store.commit("ui/toggleSearchPalette", false)
      utils.Record(record).openPage()

      this.updateSearchHistory()

      this.search_open = false
      this.query = ""
    },
    updateSearchHistory() {
      this.search_history = this.$store.state.ui_options?.palette_search_history ? this.$store.state.ui_options.palette_search_history : []
      if (!this.search_history.includes(this.query)) {
        this.search_history.unshift(this.query)
        if (this.search_history && this.search_history.length > 4) {
          this.search_history.pop()
        }
        this.$store.dispatch("ui/setUIValue", {
          palette_search_history: this.search_history
        })
      }
    },

    findRecords() {
      this.is_searching = true
      let object_type = ""
      let term = String(this.query)
      let filters = { filter: [], object_types: [] }
      let object_types = []
      if (this.selected_object_types.length > 0 && this.selected_object_types[0].type != this.$t("All")) {
        object_types = this.selected_object_types.map((x) => x?.type).filter((x) => x)
      } else {
        object_types = this.$store.state.object_types.map((x) => x?.type).filter((x) => x)
      }

      filters = { name: term, types: object_types.join(",") }
      dataService
        .fastRecordsSearch(filters)
        .then((res) => {
          let filtered_users = this.$store.state.data.users
            .filter((user) => Record.from(user).full_name.toLowerCase().search(term.toLowerCase()) != -1)
            .map((u) => {
              u["type"] = "user"
              return u
            })
          if (object_type != "") {
            const results_with_names = res.data.results.map((r) => {
              return {
                ...r,
                name: this.$utils.getRecordName(r)
              }
            })

            this.filtered_items = utils.groupBy(results_with_names.concat(filtered_users), "type")
          } else {
            this.filtered_items = utils.groupBy(res.data.results, "type")
          }
          this.is_searching = false
          this.search_open = true
        })
        .catch(() => {
          this.filtered_items = []
          this.is_searching = false
        })
    }
  }
}
</script>
